<div class="container">
  <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="clearClick()">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail" (click)="submitClick()">
      <mat-icon>done</mat-icon> Submit
    </button>
  </div>

  <div class="bgv">
    <form [formGroup]="newRequestForm">

      <!-- Vessel Name -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Vessel Name:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Vessel Name'"
            [controlname]="newRequestForm.controls['vessel_name']">
          </app-custom-input>
        </div>
      </div>

      <!-- Vessel IMO -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Vessel IMO:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Vessel IMO'"
            [controlname]="newRequestForm.controls['vessel_imo']">
          </app-custom-input>
        </div>
      </div>

      <!-- Segment -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Segment:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown [placeholder]="'Select Segment'"
            [items]="segmentOptions"
            [controlname]="newRequestForm.controls['segment']">
          </app-custom-dropdown>
        </div>
      </div>

      <!-- Cargo Name -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Cargo Name:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Cargo Name'"
            [controlname]="newRequestForm.controls['gen_oil_grade']">
          </app-custom-input>
        </div>
      </div>

      <!-- Voyage Number -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Voyage Number:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Voyage Number'"
            [controlname]="newRequestForm.controls['voy_num']">
          </app-custom-input>
        </div>
      </div>

      <!-- Total Tanks
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Total Tanks:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Total Tanks'"
            [controlname]="newRequestForm.controls['totalTanks']">
          </app-custom-input>
        </div>
      </div> -->

      <!-- Start Latitude -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Start Latitude:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Start Latitude'"
            [controlname]="newRequestForm.controls['startLatitude']">
          </app-custom-input>
        </div>
      </div>

      <!-- Start Longitude -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Start Longitude:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Start Longitude'"
            [controlname]="newRequestForm.controls['startLongitude']">
          </app-custom-input>
        </div>
      </div>

      <!-- End Latitude -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>End Latitude:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'End Latitude'"
            [controlname]="newRequestForm.controls['endLatitude']">
          </app-custom-input>
        </div>
      </div>

      <!-- End Longitude -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>End Longitude:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'End Longitude'"
            [controlname]="newRequestForm.controls['endLongitude']">
          </app-custom-input>
        </div>
      </div>

      <!-- Start Port -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Start Port:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Start Port'"
            [controlname]="newRequestForm.controls['startPort']">
          </app-custom-input>
        </div>
      </div>

      <!-- Destination Port -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Destination Port:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Destination Port'"
            [controlname]="newRequestForm.controls['destinationPort']">
          </app-custom-input>
        </div>
      </div>

      <!-- Speed -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Speed:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Speed'"
            [controlname]="newRequestForm.controls['speed']">
          </app-custom-input>
        </div>
      </div>

      <!-- Forecast Days -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Forecast Days:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Forecast Days'"
            [controlname]="newRequestForm.controls['forecastDays']">
          </app-custom-input>
        </div>
      </div>

      <!-- Temperature Log Time -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Temperature Log Time:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Temperature Log Time'"
            [controlname]="newRequestForm.controls['temperatureLogTime']">
          </app-custom-input>
        </div>
      </div>

      <!-- Deck Heat Exchanger -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Deck Heat Exchanger:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown [placeholder]="'Yes / No'"
            [items]="['yes', 'no']"
            [controlname]="newRequestForm.controls['deckHeatExchanger']">
          </app-custom-dropdown>
        </div>
      </div>

      <!-- Boiler Load -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Boiler Load (%):</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Boiler Load'"
            [controlname]="newRequestForm.controls['boilerLoad']">
          </app-custom-input>
        </div>
      </div>

      <!-- Deck Steam Pressure -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Deck Steam Pressure:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Deck Steam Pressure'"
            [controlname]="newRequestForm.controls['deckSteamPressure']">
          </app-custom-input>
        </div>
      </div>

      <!-- No Of Tanks in Circulation -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>No of Tanks in Circulation:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'No of Tanks in Circulation'"
            [controlname]="newRequestForm.controls['noOfTksInCirculation']">
          </app-custom-input>
        </div>
      </div>

    </form>
  </div>
   <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="clearClick()">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail" (click)="submitClick()">
      <mat-icon>done</mat-icon> Submit
    </button>
  </div>
</div>
<br>
<br>
<br>
